'use strict';

/**
 * @ngdoc service
 * @name gfcmsApp.firebase.service
 * @description
 * # firebase.service
 * Service in the gfcmsApp.
 */
angular.module('gfcmsApp')
  .service('firebaseService', function(appSettings, $firebaseArray) {

    var objectArray = [];
    var service = {};
    
    service.initialize = initialize;
    service.getAll = getAll;
    service.create = create;

    return service;

    function initialize(objectName) {
      return getDataArray(objectName);
    }

    function getAll(objectName) {
      return objectArray;
    }

    function getById(id, array) {
      return array.$getRecord(id);
    }

    function create(object, array) {
      array.$add(object);
    }

    function update(object, array) {
      array.$save(object);
    }

    function getDataArray(objectName) {
      var ref = firebase.database().ref().child(objectName); //jshint ignore:line
      return $firebaseArray(ref);
    }
  });
